import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { MaterialModule, DateAdapter, MD_DATE_FORMATS } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// Layout
import { LayoutComponent } from './layout/layout.component';
import { PreloaderDirective } from './layout/preloader.directive';
// Header
import { AppHeaderComponent } from './layout/header/header.component';
// Sidenav
import { AppSidenavComponent } from './layout/sidenav/sidenav.component';
import { ToggleOffcanvasNavDirective } from './layout/sidenav/toggle-offcanvas-nav.directive';
import { AutoCloseMobileNavDirective } from './layout/sidenav/auto-close-mobile-nav.directive';
import { AppSidenavMenuComponent } from './layout/sidenav/sidenav-menu/sidenav-menu.component';
import { AccordionNavDirective } from './layout/sidenav/sidenav-menu/accordion-nav.directive';
import { AppendSubmenuIconDirective } from './layout/sidenav/sidenav-menu/append-submenu-icon.directive';
import { HighlightActiveItemsDirective } from './layout/sidenav/sidenav-menu/highlight-active-items.directive';

// Footer
import { AppFooterComponent } from './layout/footer/footer.component';
// Pages
import { DashboardComponent } from './calculate/dashboard/dashboard.component';

// Sub modules
import { LayoutModule } from './layout/layout.module';

import { HttpClientService } from './utils/http-client.module';
import { CalculateService } from './calculate/calculate.service';
import { EncryptService } from './encrypt/encrypt-util';
import { Md5 } from 'ts-md5/dist/md5';
import { SignInService } from './common/sign-in/sign-in.service';
import { CookieClientService } from './utils/cookieClient';
import { CookieModule } from 'ngx-cookie';
import { AuthenticateService } from './auth/authentication.service';
import { PageForm } from './calculate/form.model';
import {CustomDateAdapter} from './utils/custom-date-adapter';
import {NgxPaginationModule} from 'ngx-pagination';
import {PagerService} from './utils/page.service';
import { DatexPipe} from './utils/dateFormat';
import { ErrorManager} from './utils/errorManager';
import { IeHackService} from './utils/msieComponentLoad';
// hmr
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';

const MY_DATE_FORMATS = {
  parse: {
    dateInput: {month: 'short', year: 'numeric', day: 'numeric'}
  },
  // dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  dateInput: 'input',
  monthYearLabel: {year: 'numeric', month: 'short'},
  dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
  monthYearA11yLabel: {year: 'numeric', month: 'long'}
};

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    HttpModule,
    FormsModule,
    MaterialModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CookieModule.forRoot(),
    // Sub modules
    NgxPaginationModule,
    LayoutModule

  ],
  declarations: [
    AppComponent,
    // Layout
    LayoutComponent,
    PreloaderDirective,
    // Header
    AppHeaderComponent,
    // Sidenav
    AppSidenavComponent,
    ToggleOffcanvasNavDirective,
    AutoCloseMobileNavDirective,
    AppSidenavMenuComponent,
    AccordionNavDirective,
    AppendSubmenuIconDirective,
    HighlightActiveItemsDirective,
    // Footer
    AppFooterComponent,
    //
    DashboardComponent
  ],
  providers: [
    HttpClientService,
    CalculateService,
    EncryptService,
    Md5,
    SignInService,
    CookieClientService,
    AuthenticateService,
    PageForm,
    PagerService,
    ErrorManager,
    IeHackService,
    {provide:DateAdapter, useClass:CustomDateAdapter},
    {provide: MD_DATE_FORMATS, useValue: MY_DATE_FORMATS}
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(public appRef: ApplicationRef) {
  }
  hmrOnInit(store) {
    console.log('HMR store', store);

  }
  hmrOnDestroy(store) {
    const cmpLocation = this.appRef.components.map((cmp) => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}




// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/app.module.ts